import Layout from "modules/layout/dashboard"
import { useInvoiceId, useMemberId } from "pages/member"
import { useMember } from "pages/member/queries"
import { useInvoice } from "../../queries"
import { Card, Col, Descriptions, Row, Typography } from "antd"
import styles from "./styles.module.scss"
import { banks } from "./banks"
import { Trans, useTranslation } from "react-i18next"
import moment from "moment"
const { Main } = Layout
const { Title, Text } = Typography

const Pay: React.FC = () => {
  const { t } = useTranslation()
  const memberId = useMemberId()
  const invoiceId = useInvoiceId()
  const member = useMember(memberId)
  const invoice = useInvoice(memberId!, invoiceId!)
  return (
    <>
      <Main.PageHeader
        breadcrumbs={[
          {
            title: member.data?.name,
            link: `/members/${member.data?.id}/events`,
          },
          { title: "Factures", link: `/members/${member.data?.id}/invoices` },
          {
            title: invoice.data?.reference ?? invoice.data?.proforma_reference,
            link: `/members/${member.data?.id}/invoices/${invoice.data?.id}`,
          },
          {
            title: t("invoice.payment"),
            link: `/members/${member.data?.id}/invoices/${invoice.data?.id}/payment`,
          },
          {
            title: t("invoice.text_1"),
          },
        ]}
        title={
          <Title level={3}>
            {t("invoice.text_1", {
              entity:
                invoice.data?.reference ?? invoice.data?.proforma_reference,
            })}
          </Title>
        }
      />
      <Card>
        <Row>
          <Col md={11} sm={24}>
            <Descriptions column={1}>
              <Descriptions.Item label={t("members.member")}>
                <Text strong>{member.data?.name} </Text>
              </Descriptions.Item>
              <Descriptions.Item label={t("invoice.at_the_command_of")}>
                <Text strong>{invoice.data?.recipient.name} </Text>
              </Descriptions.Item>
              <Descriptions.Item label={t("invoice.due_date")}>
                <Text strong>
                  {moment(invoice.data?.due_date).format("DD-MM-YYYY")}
                </Text>
              </Descriptions.Item>
              <Descriptions.Item label={t("invoice.balance")}>
                <Text strong>{invoice.data?.balance}</Text>
              </Descriptions.Item>
            </Descriptions>
          </Col>
          <span className={styles.divider} />
          <Col md={11} sm={24}>
            <div>
              <Title level={5}>{t("invoice.text_9")}</Title>
              <ul className={styles.listContainer}>
                <li>
                  <Text>
                    {t("invoice.text_3")}{" "}
                    <Text strong>comptabilite@asdisherbrooke.org</Text>
                  </Text>
                </li>
                <li>
                  <Text>
                    {t("invoice.text_4")}{" "}
                    <Text strong>
                      (
                      {invoice.data?.reference ??
                        invoice.data?.proforma_reference}
                      )
                    </Text>
                  </Text>
                </li>
                <li>
                  <Trans
                    i18nKey={"invoice.text_5"}
                    t={t}
                    components={[<Text strong>asdi2227</Text>]}
                  />
                </li>
              </ul>
            </div>
          </Col>
        </Row>

        <div className={styles.banksContainer}>
          {banks.map((item) => (
            <div
              onClick={() => window.open(item.link)}
              className={styles.imageContainer}
            >
              {item.image}
            </div>
          ))}
        </div>
      </Card>
    </>
  )
}
export default Pay
